import state from './moduleClassManagementState.js'
import mutations from './moduleClassManagementMutations.js'
import actions from './moduleClassManagementActions.js'
import getters from './moduleClassManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

